// Google encoded-polyline decode at precision 5 — the format every routing engine here
// returns (Valhalla is asked for polyline5, OSRM's default, and the manual estimate is encoded
// by the server's PolyUtil). Decoding at the wrong precision silently lands points in the
// Atlantic, so this is not configurable.
const PRECISION = 1e5;

export const decodePolyline = (encoded: string | null | undefined): [number, number][] => {
  if (!encoded) return [];
  const points: [number, number][] = [];
  let index = 0;
  let lat = 0;
  let lon = 0;

  while (index < encoded.length) {
    let shift = 0;
    let result = 0;
    let byte: number;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20 && index < encoded.length);
    lat += result & 1 ? ~(result >> 1) : result >> 1;

    shift = 0;
    result = 0;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20 && index < encoded.length);
    lon += result & 1 ? ~(result >> 1) : result >> 1;

    points.push([lat / PRECISION, lon / PRECISION]);
  }

  return points;
};
